import styled from 'styled-components'
import {BodyText} from './text-body-text.js'

const Paragraph = styled(BodyText)`
  margin-bottom: .8em;
`

export default Paragraph